module.exports = [
  {
    id: "resume-editor",
    title: "Resume Editor",
    shortTitle: "Editor",
    color: "#FFD600",
    shortDescription:
      "Infographic Resume Editor for Skill and Personality Profiling.",
    description:
      "Getboarded editor is a competency mapping tool for professionals and students that helps them showcase their skills and personality. This qualitative information is used the basis for other apps to be selected and utilized for their personal development.<br><br> The editor works, not just on the knowledge skills of a person, but also personality-based transferable skills in today’s ever-changing career and jobs landscape.<br><br> It can get directly integrated/embedded into an organization website and work to create talent boards as a SaaS service. Based on the talent profiles, the system can further predict learning needs and provides future career guidance for students and early career professionals.<br><br> App is customizable to add different designs, templates and colors to suit personality or organization brand.",
    icon: require("@/assets/images/icons/app-marketplace/editor.svg"),
    uni_icon: require("@/assets/images/icons/app-marketplace/flat-icons/editor.svg"),
    strokeIcon: require("@/assets/images/icons/app-marketplace/stroke-icons/editor.svg"),
    uni_color_icon: require("@/assets/images/icons/app-marketplace/flat-icons/uni-color/editor.svg"),
    ss1: require("@/assets/images/pages/marketplace/EditorSS1.gif"),
    pricePerUser: "0",
    defaultCurreny: "eur",
    baseURL: "editor/about",
    baseURLDisabled: false,
    manager: "GetBoarded",
  },
  {
    id: "resume-parser",
    title: "Resume Parser",
    shortTitle: "Parser",
    color: "#256EE2",
    shortDescription:
      "PARSER is an AI assistant that reads your existing resume and suggests you the corresponding conversion in the editor. Activate and upload your resume.",
    description:
      "AI based resume bot that can read and contextualize your resume and automatically parse it into the GetBoarded editor. It is developed with deep learning mechanisms and trained on huge data models. Parsing happens with your career history, skills, interests, and your personality. Platform uses predictive talent analytics to map your career roadmap and predict situations.",
    icon: require("@/assets/images/icons/app-marketplace/parser.svg"),
    uni_icon: require("@/assets/images/icons/app-marketplace/flat-icons/parser.svg"),
    strokeIcon: require("@/assets/images/icons/app-marketplace/stroke-icons/parser.svg"),
    uni_color_icon: require("@/assets/images/icons/app-marketplace/flat-icons/uni-color/parser.svg"),
    pricePerUser: "0.1",
    defaultCurreny: "eur",
    baseURL: "parser",
    baseURLDisabled: false,
    manager: "GetBoarded",
  },
  // { id: 'ats', title: 'ATS', color: '#739AFF', shortDescription: '', icon: require('@/assets/images/icons/app-marketplace/ats.svg') },
  {
    id: "alex",
    title: "Library",
    shortTitle: "Library",
    color: "#F53855",
    shortDescription:
      "Library, an app with diverse learning resources for personalized competency development.",
    description:
      "Library uses learning recommendation engine that adds additional capabilities to your learning and development programs by personalizing based on individual needs and preferences. Additionally, the organization can hyper-personalize each training path for all participating individuals with journeys while leveraging on your internal training material.<br><br> Library initiates learning recommendations based on your current development needs assessed by you and your peers. Once initial benchmark is in place the algorithm evolves with recursive feedback mechanisms allowing the learner to customize their own learning habits and providing an effective and engaging experience using Microlearning content. This content in the training library also gets dynamically re-arranged and ranked with learner’s quality feedback improving the organizational knowledge base over time.<br><br> By using a hyper-personalization approach to one-to-one Distributed Development in a digital-first environment. Our adaptive learning models allow for efficient scale to whole of the organization while catering to each individual need.",
    icon: require("@/assets/images/icons/app-marketplace/library.svg"),
    uni_icon: require("@/assets/images/icons/app-marketplace/flat-icons/library.svg"),
    strokeIcon: require("@/assets/images/icons/app-marketplace/stroke-icons/library.svg"),
    uni_color_icon: require("@/assets/images/icons/app-marketplace/flat-icons/uni-color/library.svg"),
    pricePerUser: "30",
    defaultCurreny: "eur",
    baseURL: "dpd-belux/alex/home",
    baseURLDisabled: false,
    manager: "GetBoarded",
  },
  // {
  //   id: "alfred",
  //   title: "ALFRED",
  //   shortTitle: "ALFRED",
  //   color: "#F53855",
  //   shortDescription:
  //     "ALFRED is a learning bot that suggests you microlearning based on your career-oriented development needs",
  //   description:
  //     "ALFRED helps you form mini habits of continuous development and lifelong learning by suggesting you microlearning content. It collects your preferences and send you recommendations in the format and at the time of your convenience.",
  //   icon: require("@/assets/images/icons/app-marketplace/alfred.svg"),
  //   strokeIcon: require("@/assets/images/icons/app-marketplace/stroke-icons/alfred.svg"),
  //   pricePerUser: "5",
  //   defaultCurreny: "eur",
  //   baseURL: "dpd-belux/alex/home",
  //   baseURLDisabled: false,
  //   manager: "GetBoarded",
  // },
  {
    id: "journey",
    title: "Journey",
    shortTitle: "Journey",
    color: "#0EB71F",
    shortDescription:
      "Personalized career paths for your organizational internal talent development.",
    description:
      "Personalized career paths for your organizational internal talent development. Create customized interactive journeys for your talent to work through gamified sequence of tasks.",
    icon: require("@/assets/images/icons/app-marketplace/journey.svg"),
    uni_icon: require("@/assets/images/icons/app-marketplace/flat-icons/journey.svg"),
    strokeIcon: require("@/assets/images/icons/app-marketplace/stroke-icons/journey.svg"),
    uni_color_icon: require("@/assets/images/icons/app-marketplace/flat-icons/uni-color/journey.svg"),
    pricePerUser: "30",
    defaultCurreny: "eur",
    baseURL: "journey",
    baseURLDisabled: true,
    manager: "GetBoarded",
  },
  {
    id: "abilities",
    title: "Career Lab",
    shortTitle: "Career Lab",
    color: "#F53855",
    shortDescription:
      "Career Lab for behavioural self-discovery and professional development.",
    description:
      "Career Lab is a competency mapping extension based on the Talent Genome. It allows users to self-assess and peer-assess professional behavioral attributes with a positively enforced feedback mechanism. Your own view of yourself is mapped to how other people see you and thus any gaps are identified and presented in a talent report. Being aware of your weaknesses and playing on your strengths will help you discover and tap into the potential you have, or in contrast, seek development support in areas which you realize you are lacking skill. As there is no negative manner of feedback collected, the data helps career counselors in universities or HRs in an organization to find proper fitment of people with roles and help plan career succession. A lot of further capabilities could be explored when you tap into the soft skill data with this extension. Recommendations of learning, planning for next level roles for succession, talent planning are a few examples.",
    icon: require("@/assets/images/icons/app-marketplace/ability-lab.svg"),
    uni_icon: require("@/assets/images/icons/app-marketplace/flat-icons/ability-lab.svg"),
    strokeIcon: require("@/assets/images/icons/app-marketplace/stroke-icons/ability-lab.svg"),
    uni_color_icon: require("@/assets/images/icons/app-marketplace/flat-icons/uni-color/ability-lab.svg"),
    baseURL: "editor/personality",
    baseURLDisabled: false,
    pricePerUser: "0",
    defaultCurreny: "eur",
    manager: "PeopleTree International",
  },
  // {
  //     id: 'comm-server',
  //     title: 'Comm Server',
  //     color: '#DC3D41',
  //     shortDescription: 'Comm server allows peer to peer messaging between the users on different board channels.',
  //     description: 'Comm server allows peer to peer messaging between the users on different board channels. It is an easy extension that enables quick chat features within your board users. It makes communication easier and you can instantly connect with those on the server and carry on a conversation without needing to switch to another app or marketplace.',
  //     icon: require('@/assets/images/icons/app-marketplace/comm-server.svg'),
  //     pricePerUser: '1.46',
  //     baseURL: 'comm',
  //     baseURLDisabled: true,
  //     manager: 'GetBoarded'
  // },
  {
    id: "coach",
    title: "Mentor",
    shortTitle: "Mentor",
    color: "#9DCD5B",
    shortDescription:
      "It is a coaching experience tracking app that manages the behavioral skill development progress by suggesting simple development actions, while getting feedback from advisors who validate visible change.",
    description:
      "Mentor helps you add skills to develop with pre-defined and custom progress measures. Your coaching relationship is defined in the app that allows both the trainee and the coach to continuously work using planned touchpoints. Other than your coaches, you can build an advisor circle of people who provide you feedback on the progress you make in selected skills. The development analytics shows you if you are decreasing on increasing the gap of your chosen skill with periodic inputs from your selected advisors.",
    icon: require("@/assets/images/icons/app-marketplace/coach.svg"),
    uni_icon: require("@/assets/images/icons/app-marketplace/flat-icons/coach.svg"),
    strokeIcon: require("@/assets/images/icons/app-marketplace/stroke-icons/coach.svg"),
    uni_color_icon: require("@/assets/images/icons/app-marketplace/flat-icons/uni-color/coach.svg"),
    pricePerUser: "30",
    defaultCurreny: "eur",
    baseURL: "comm",
    baseURLDisabled: true,
    manager: "PeopleTreeGroup",
  },
  // { id: 'dex', title: 'DEX', color: '#A965FF', shortDescription: '', icon: require('@/assets/images/icons/app-marketplace/dex.svg') },
  // { id: 'opex', title: 'OPEX', color: '#F2C244', shortDescription: '', icon: require('@/assets/images/icons/app-marketplace/opex.svg') },
  // { id: 'digital-footprint', title: 'Digital Footprint', color: '#00D0BF', shortDescription: 'Digital footprint is a simple tool to review your open indexable data on the internet. It spiders the web  for all social accounts related to your email and gives you back results.', icon: require('@/assets/images/icons/app-marketplace/digital-footprint.svg') },
  // { id: 'api-explorer', title: 'API Explorer', color: '#F2C244', shortDescription: '', icon: require('@/assets/images/icons/app-marketplace/api-explorer.svg') },
  // { id: 'my-coach', title: 'My Coach', color: '#84B234', shortDescription: '', icon: require('@/assets/images/icons/app-marketplace/mycoach.svg') },
  // {
  //   id: "hibob",
  //   title: "HiBob",
  //   shortTitle: "HiBob",
  //   color: "#D33F55",
  //   shortDescription:
  //     "Bob is a cloud-based human resource (HRIS) platform that allows companies to streamline HR processes and engage top talent.",
  //   description:
  //     "Bob is an HRIS (Human Resource Information System) that stores, manages, and tracks employee-related data.\n From out-of-the-box onboarding, workflows, performance management, and compensation management to integrations with leading payroll providers and more—Bob's breadth of core HR functionally gives your team everything needed to operate efficiently.",
  //   icon: require("@/assets/images/icons/app-marketplace/hibob.svg"),
  //   strokeIcon: require("@/assets/images/icons/app-marketplace/stroke-icons/hibob.svg"),
  //   pricePerUser: "10",
  //   defaultCurreny: "eur",
  //   baseURL: "hibob",
  //   baseURLDisabled: true,
  //   manager: "PeopleTreeGroup",
  // },
  {
    id: "videowiki-cast",
    title: "VideoWiki Cast",
    shortTitle: "Cast",
    color: "#9B6BF6",
    shortDescription:
      "Cast is a VideoWiki product for event scheduling and audience management. Turn your events into NFT fanclubs and explore web 3 conferencing.",
    description:
      "At VideoWiki, creators can launch events and cast them on various platforms by scheduling and sharing a link for the conference. Create breakout rooms, share presentations, or watch in-sync videos through external links, share notes and interact with audience in a white board live presentation.",
    icon: require("@/assets/images/icons/app-marketplace/cast.svg"),
    uni_icon: require("@/assets/images/icons/app-marketplace/flat-icons/cast.svg"),
    strokeIcon: require("@/assets/images/icons/app-marketplace/stroke-icons/videowiki-cast.svg"),
    uni_color_icon: require("@/assets/images/icons/app-marketplace/flat-icons/uni-color/cast.svg"),
    pricePerUser: "2.25",
    defaultCurreny: "eur",
    baseURL: "videowiki",
    baseURLDisabled: true,
    manager: "VideoWiki",
  },
  {
    id: "videowiki-room",
    title: "VideoWiki Room",
    shortTitle: "Rooms",
    color: "#7367f0",
    shortDescription:
      "VideoWiki has many solutions that can be sold at different prices to Orgs. This one is for Rooms. Integrate the BETA VW ORG account.",
    description:
      "At VideoWiki, creators can launch events and cast them on various platforms by scheduling and sharing a link for the conference. Create breakout rooms, share presentations, or watch in-sync videos through external links, share notes and interact with audience in a white board live presentation.",
    icon: require("@/assets/images/icons/app-marketplace/room.svg"),
    uni_icon: require("@/assets/images/icons/app-marketplace/flat-icons/room.svg"),
    strokeIcon: require("@/assets/images/icons/app-marketplace/stroke-icons/room.svg"),
    uni_color_icon: require("@/assets/images/icons/app-marketplace/flat-icons/uni-color/room.svg"),
    pricePerUser: "1.25",
    defaultCurreny: "eur",
    baseURL: "videowiki",
    baseURLDisabled: true,
    manager: "VideoWiki",
  },
  {
    id: "market",
    title: "Market",
    shortTitle: "Market",
    color: "#F79009    ",
    shortDescription:
      "Market App is a marketplace that we want to give to organizations to configure (setup with a GUI) so they can upload information about what their employees can purchase. The unique thing is that employees will be paying in terms of Points that they earn by doing small learning items",
    description:
      "The App is designed to provide organizations with an easy-to-use platform to offer merchandise. The products can be listed and tied to a point-based learning reward. People can earn points by completing small learning tasks or by engaging in other activities that support their professional development. These points can then be redeemed for a range of rewards that are uploaded by the organization. The app provides a simple and efficient way for organizations to incentivize and recognize people efforts towards skill-building and continuous learning.",
    icon: require("@/assets/images/icons/app-marketplace/market.svg"),
    uni_icon: require("@/assets/images/icons/app-marketplace/flat-icons/market.svg"),
    strokeIcon: require("@/assets/images/icons/app-marketplace/stroke-icons/giftsshop.svg"),
    uni_color_icon: require("@/assets/images/icons/app-marketplace/flat-icons/uni-color/market.svg"),
    pricePerUser: "",
    defaultCurreny: "",
    baseURL: "",
    baseURLDisabled: true,
    manager: "Getboarded",
  },
];
